<!--
 * @name: 设置密码
 * @description: 设置密码
 * @author: huizi(huizi.li@shengyc.com)
 * @Date: 2019-11-13 17:22:07
 * @LastEditTime: 2021-11-12 09:53:59
 -->
<template>
    <div class="main-container">
        <div class="main-header-bg"></div>
        <div class="main-content">
            <div class="main-header-wrap">
                <div class="main-login-top">
                    <img
                        v-if="
                            $store.state.headerImage &&
                                (($store.state.account_origin &&
                                    $store.state.account_origin !== 'not_staff') ||
                                    $store.state.historyAccountType)
                        "
                        :src="$store.state.headerImage"
                        alt=""
                        class="avatar-logo"
                    />
                    <img v-else src="@/assets/images/icon_avatar_1.png" alt="" class="avatar-logo" />
                    <span
                        v-if="
                            ($store.state.account_origin && $store.state.account_origin !== 'not_staff') ||
                                $store.state.historyAccountType
                        "
                    >
                        您好
                        <span v-if="$store.state.user_name">, {{ $store.state.user_name }}</span>
                    </span>
                    <span v-else @click="goLogin">您好，请登录</span>
                    <div class="spacer">
                        <img
                            src="@/assets/images/icon_unfold_1.png"
                            alt=""
                            class="logo-left"
                            @click="openPoper"
                        />
                    </div>
                </div>
                <div class="main-login-img">
                    <img src="@/assets/images/icon_banner.png" alt="" />
                </div>
            </div>
            <div class="main-wrap">
                <div v-for="(item, index) in routeArr" :key="index">
                    <div
                        v-if="
                            !item.hidden &&
                                !(item.name === '厂商公众号' && !companyQr) &&
                                getSonPermision(item.contents)
                        "
                        class="main-item"
                    >
                        <div class="item-top">
                            {{ item.name }}
                        </div>
                        <div class="item-wrap">
                            <template v-for="(content, idx) in item.contents">
                                <div
                                    :key="idx"
                                    class="item-icon item-icon-wrap"
                                    v-if="account_permission[content.code] || !content.code"
                                >
                                    <div class="item-group" @click="drowPage(content)">
                                        <div
                                            class="red-point"
                                            v-if="woListTotal && content.name === '待评价'"
                                        ></div>
                                        <img :src="content.icon" alt="" class="item-image" />
                                        <div class="item-title">{{ content.name }}</div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isWeiXin, getUrlKey, pathOr } from '@/config/Utils'
import { Dialog, Toast } from 'vant'
import {
    get_to_evaluate_list,
    get_scan_qr_permission,
    getCompanyInfo,
    getNoLoginCompanyInfo
} from '@/service/getData'
import Message from '@/components/common/Message'
export default {
    name: 'Main',
    components: {},
    data() {
        return {
            routeArr: [],
            woListTotal: 0,
            companyQr: '',
            account_permission: {}
        }
    },
    created() {
        this.getMainPermission()
    },

    mounted() {
        // ios 微信返回上一页会读取缓存的快照页面，做刷新处理
        window.addEventListener('pageshow', function(event) {
            if (event.persisted) {
                window.location.reload()
            }
        })
    },

    methods: {
        init() {
            document.title = this.$store.state.company_name || '首页'
            // 清空equipId
            this.$store.commit('setAsideMenuData', { isEquip: false, equipId: '' })
            this.get_company_qr()
            // 盛云宝获取未评价工单
            if (this.$store.state.account_origin === 'smas') {
                this.get_to_evaluate_list()
            }
            this.account_permission = this.$store.state.account_permission || {}
            if (this.$store.state.account_origin === 'oem') {
                // 盛云猫账号的首页
                this.routeArr = [
                    {
                        name: '常用应用',
                        contents: [
                            {
                                name: '设备信息',
                                code: 'choice_equipment_son',
                                path: '/equitmentSearchScreen',
                                icon: require('@/assets/images/icon_device.png')
                            }
                        ]
                    },
                    {
                        name: '厂商公众号',
                        contents: [
                            {
                                name: '二维码',
                                path: '/companyScreen',
                                permission: true,
                                icon: require('@/assets/images/icon_code.png')
                            }
                        ]
                    }
                ]
            } else {
                // 其他的首页
                this.routeArr = [
                    {
                        name: '服务信息',
                        contents: [
                            {
                                name: '服务申报',
                                path: '/serviceDeclaration',
                                code: 'service_declaration',
                                permission: true,
                                icon: require('@/assets/images/icon_serve.png')
                            },
                            {
                                name: '服务信息',
                                path: '/selectServiceOrder',
                                code: 'service_info_son',
                                icon: require('@/assets/images/icon_view.png'),
                                query: {
                                    fromType: 'serviceInfo'
                                }
                            },
                            {
                                name: '待评价',
                                code: 'no_evaluate',
                                path: '/ToEvaluateOrderList',
                                icon: require('@/assets/images/icon_judge.png'),
                                query: {
                                    fromType: 'evaluate'
                                }
                            }
                        ]
                    },
                    {
                        name: '反馈投诉',
                        contents: [
                            {
                                name: '提交反馈',
                                code: 'feedback',
                                path: '/feedbackScreen',
                                permission: true,
                                icon: require('@/assets/images/icon_feed.png'),
                                query: {
                                    FC_type: 'feedback'
                                }
                            },
                            {
                                name: '提交投诉',
                                code: 'complaints',
                                path: '/complaintsScreen',
                                permission: true,
                                icon: require('@/assets/images/icon_complaint.png'),
                                query: {
                                    FC_type: 'complaints'
                                }
                            },
                            {
                                name: '进度列表',
                                code: 'feedback_complaints_list',
                                path: '/feedbackScreenList',
                                icon: require('@/assets/images/icon_rate.png')
                            }
                        ]
                    },
                    {
                        name: '常用应用',
                        code: 'choice_equipment_son',
                        contents: [
                            {
                                name: '设备信息',
                                code: 'equipment_info',
                                path: '/equitmentSearchScreen',
                                icon: require('@/assets/images/icon_device.png')
                            },
                            {
                                name: '商城',
                                path: '',
                                code: 'mall_son',
                                icon: require('@/assets/images/icon_shop_1.png')
                            },
                            {
                                name: '报警设置',
                                path: '/warmSearchScreen',
                                code: 'warning_setting_son',
                                icon: require('@/assets/images/icon_alarm@2x.png')
                            }
                        ]
                    },
                    {
                        name: '厂商公众号',
                        contents: [
                            {
                                name: '二维码',
                                path: '/companyScreen',
                                permission: true,
                                icon: require('@/assets/images/icon_code.png')
                            }
                        ]
                    }
                ]
            }
        },
        // 获取
        getMainPermission() {
            // 当租户id存在且跟当前登录不一样
            let platform_id =
                getUrlKey('platformId') ||
                (this.$route && this.$route.query.platformId) ||
                this.$store.state.platform_id
            // 当路由租户id
            if (
                platform_id &&
                (this.$store.state.account_origin === 'not_staff' || !this.$store.state.account_origin)
            ) {
                this.$store.commit('updatePlatformId', platform_id)
                get_scan_qr_permission({
                    platformId: platform_id
                }).then(res => {
                    this.$store.commit('set_account_origin', pathOr('', ['user_origin'], res))
                    this.$store.commit('set_account_permission', pathOr({}, ['qr_permission'], res))
                    this.$store.commit('get_user_origin', pathOr('', ['user_origin'], res))
                    this.$store.commit('get_qr_permission', pathOr({}, ['qr_permission'], res))
                    this.init()
                })
            } else {
                this.init()
            }
        },
        // 获取全部轮询
        getSonPermision(arr) {
            let flag = false
            arr.forEach(item => {
                if (this.account_permission[item.code] || !item.code) {
                    flag = true
                }
            })
            return flag
        },
        get_company_qr() {
            this.companyQr = ''
            let that = this
            // 当租户id存在且跟当前登录不一样
            let platform_id = this.$store.state.platform_id
            if (
                localStorage.getItem(location.host + 'appId') &&
                localStorage.getItem(location.host + 'token')
            ) {
                // 获取租户二维码，用租户id
                getCompanyInfo({ id: platform_id }).then(res => {
                    res.companyQr && that.$store.commit('updateCompany', res.name)
                    document.title = this.$store.state.company_name || '首页'
                    this.companyQr = res.companyQr
                })
            } else if (platform_id) {
                getNoLoginCompanyInfo({
                    id: this.$store.state.platform_id
                }).then(res => {
                    res.name && that.$store.commit('updateCompany', res.name)
                    document.title = this.$store.state.company_name || '首页'
                    this.companyQr = res.companyQr
                })
            }
        },
        // 打开抽屉
        openPoper() {
            if (
                (this.$store.state.account_origin && this.$store.state.account_origin !== 'not_staff') ||
                this.$store.state.historyAccountType
            ) {
                this.$store.commit('changeShowRightPopup', true)
            } else {
                this.goLogin()
            }
        },
        $_goService() {
            let platform_id = this.$store.state.platform_id
            let eqCode = localStorage.getItem(location.host + 'equipment_code')
            if (
                (this.$store.state.account_origin === 'not_staff' || !this.$store.state.account_origin) &&
                !this.$store.state.historyAccountType
            ) {
                location.href = `${
                    process.env.VUE_APP_URL_WELINK
                }h5/index.html?platform_id=${encodeURIComponent(
                    platform_id || ''
                )}&type=apph5Service&eqCode=${encodeURIComponent(eqCode || '')}&notStaff=1&redirect=main#/` //platform_id平台id tenantId租户id equipmentCode设备编号
            } else {
                this.$router.push({
                    path: '/serviceDeclaration',
                    query: {
                        platform_id: platform_id,
                        fromType: 'main'
                    }
                })
            }
        },
        // 获取未评价的工单
        get_to_evaluate_list() {
            get_to_evaluate_list({
                token: localStorage.getItem(location.host + 'token')
            })
                .then(res => {
                    console.log(res)
                    this.woListTotal = res.total
                })
                .catch(err => {
                    this.loading = false
                })
        },
        $_login() {
            //需要重定向跳转页面，所以只能在这里进行手动授权
            let redirect_uri = encodeURIComponent(
                // eslint-disable-next-line no-undef
                process.env.VUE_APP_URL_WELINK + '#/login?from_path=' + this.$route.path
            )
            window.location.href =
                'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
                process.env.VUE_APP_WX_AUTHOR_APPID +
                '&redirect_uri=' +
                redirect_uri +
                '&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect'
        },
        goLogin() {
            if (isWeiXin()) {
                this.$_login()
            } else {
                this.$store.commit('updateLoginTabName', 'smas_login')
                this.$router.push('/login')
            }
        },
        drowPage(content) {
            if (
                (this.$store.state.account_origin && this.$store.state.account_origin !== 'not_staff') ||
                content.permission ||
                this.$store.state.historyAccountType
            ) {
                if (content.name === '商城') {
                    this.$_goCart()
                } else if (content.name === '服务申报') {
                    this.$_goService()
                } else {
                    // 跳转到对应页面
                    this.$router.push({
                        path: content.path,
                        query: content.query
                    })
                }
            } else {
                this.goLogin()
            }
        },
        // 往下是跳转商城操作
        urlCvalidation(url) {
            let newUrl = url
            let origin = newUrl.split('#')[0]
            let params = newUrl.split('?')
            let router = newUrl.split('?')[0].split('#')[1]
            newUrl = origin + '?'
            for (let i = 1; i < params.length; i++) {
                newUrl += params[i]
            }
            newUrl += '#' + router
            return newUrl
        },
        addUrlPara(url, name, value) {
            if (url) {
                var currentUrl = url
                if (/\?/g.test(currentUrl)) {
                    if (/name=[-\w]{4,25}/g.test(currentUrl)) {
                        currentUrl = currentUrl.replace(/name=[-\w]{4,25}/g, name + '=' + value)
                    } else {
                        currentUrl += '&' + name + '=' + value
                    }
                } else {
                    currentUrl += '?' + name + '=' + value
                }
                url = currentUrl
                return url
            } else {
                return ''
            }
        },
        // 跳去商城
        async $_goCart() {
            if (localStorage.getItem(location.host + 'type') == 1 && isWeiXin()) {
                this.$store.commit('updateLoginTabName', 'smas_login')
                let redirect_uri = encodeURIComponent(
                    // eslint-disable-next-line no-undef
                    process.env.VUE_APP_URL_WELINK + '#/login'
                )
                window.location.href =
                    'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
                    process.env.VUE_APP_WX_AUTHOR_APPID +
                    '&redirect_uri=' +
                    redirect_uri +
                    '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
                let code = { code: getUrlKey('code') }
                return false
            }
            let url = ''
            // 跳商城
            url = process.env.VUE_APP_URL_SHOP_ADDRESS + '#/'
            url = this.addUrlPara(url, 'unique_id', localStorage.getItem(location.host + 'unique_id'))
            url = this.addUrlPara(url, 'date', new Date().getTime())
            url = this.addUrlPara(url, 'tenantId', localStorage.getItem('tenantId'))
            url = this.addUrlPara(url, 'token', localStorage.getItem(location.host + 'token'))
            url = this.urlCvalidation(url)
            location.href = url
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/mixin';
@mixin m-b($n: 10) {
    margin-bottom: vw($n);
}
@mixin b-r($n: 4) {
    border-radius: ($n + px);
}
.main-container {
    font-family: PingFang SC;
    font-weight: 400;
    background: #f3f3f3;
    @include wh(100vw, 100%);
    position: relative;
    -webkit-overflow-scrolling: touch; //实现苹果手机的滚动回弹效果
    .main-header-bg {
        position: absolute;
        width: 100%;
        height: vw(160);
        z-index: 1;
        background-image: -webkit-linear-gradient(#3661ff, #7bb3ff, #f3f3f3);
    }
    .main-content {
        position: absolute;
        @include wh(100vw, 100%);
        flex-direction: column;
        overflow: hidden;
        position: relative;
        padding: vw(16) vw(16);
        padding-bottom: 0;
        z-index: 2;
        display: flex;
        .main-wrap {
            flex: 1;
            overflow: auto;
        }
    }
    .main-login-top {
        display: flex;
        align-items: center;
        @include m-b(15);
        .avatar-logo {
            width: vw(48);
            height: vw(48);
            border-radius: vw(24);
            margin-right: vw(16);
        }
        span {
            color: white;
            font-size: vw(16);
            font-weight: 400;
        }
        .spacer {
            flex: 1;
            text-align: right;
            .logo-left {
                color: white;
                width: vw(24);
                height: vw(24);
            }
        }
    }
    .main-login-img {
        width: 100%;
        height: vw(60);
        @include m-b(10);
        img {
            width: 100%;
            height: vw(60);
            @include b-r(4);
        }
    }
    .main-wrap {
        width: 100%;
        .main-item {
            width: 100%;
            vertical-align: top;
            padding: vw(14) vw(16);
            background: white;
            @include m-b(10);
            @include b-r(4);
            .item-top {
                font-size: vw(16);
                margin-bottom: vw(12);
            }
            .item-wrap {
                .item-icon {
                    width: 33.3%;
                    vertical-align: top;
                    display: inline-block;
                    .item-group {
                        width: vw(76);
                        display: inline-block;
                        text-align: center;
                        position: relative;
                        .red-point {
                            position: absolute;
                            right: vw(8);
                            top: vw(-4);
                            width: vw(8);
                            height: vw(8);
                            border-radius: vw(4);
                            background: #ff6085;
                        }
                    }
                    .item-image {
                        width: vw(48);
                        height: vw(48);
                        padding: 0 vw(14);
                        margin-bottom: vw(12);
                    }
                    .item-title {
                        font-size: vw(14);
                    }
                }
            }
            .item-wrap {
                .item-icon-wrap:nth-child(3n - 1) {
                    text-align: center;
                }
                .item-icon-wrap:nth-child(3n - 0) {
                    text-align: right;
                }
                .item-icon-wrap:nth-child(3n - 2) {
                    text-align: left;
                }
            }
        }
    }
}
</style>
